import { createApiInstance, RetryPolicy } from "./apiClient";

const url = process.env.REACT_APP_PRODUCT_API_URL;

const isCanceledRequest = (error) => error?.code === "ERR_CANCELED" || error?.name === "CanceledError";

export const getVendorsAndManufacturers = async () => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/search`, retry: RetryPolicy.NetworkErrorsOnly });

		let requestUrl = `/vendors-and-manufacturers`;
		return await instance
			.get(requestUrl)
			.then((response) => {
				if (response.status === 200)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};

export const getVendors = async () => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/search`, retry: RetryPolicy.NetworkErrorsOnly });

		let requestUrl = `/vendors`;
		return await instance
			.get(requestUrl)
			.then((response) => {
				if (response.status === 200)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};

export const getPartNumbersByVendor = async (vendor) => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/search`, retry: RetryPolicy.NetworkErrorsOnly });

		let requestUrl = `/part-numbers-by-vendor?vendor=${encodeURIComponent(vendor)}`;
		return await instance
			.get(requestUrl)
			.then((response) => {
				if (response.status === 200)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};

export const getVehicleByRegistration = async (reg, vin) => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/search`, retry: RetryPolicy.NetworkErrorsOnly });

		let requestUrl = `/reg/${encodeURIComponent(reg)}${vin ? `?vin=${encodeURIComponent(vin)}` : ""}`;
		return await instance
			.get(requestUrl)
			.then((response) => {
				if (response.status === 200)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};

export const getVehicleByVin = async (vin, reg) => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/search`, retry: RetryPolicy.NetworkErrorsOnly });

		let requestUrl = `/vin/${encodeURIComponent(vin)}${reg ? `?reg=${encodeURIComponent(reg)}` : ""}`;
		return await instance
			.get(requestUrl)
			.then((response) => {
				if (response.status === 200)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};

export const getSearchSuggestions = async (
	searchTerm,
	{ signal } = {}
) => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/search/`, retry: RetryPolicy.None });

		let requestUrl = `suggestions?searchString=${encodeURIComponent(searchTerm)}`;
		requestUrl += "&limitProducts=5";
		requestUrl += "&limitSkuProducts=5";
		requestUrl += "&limitCategories=5";

		return await instance
			.get(requestUrl, { signal })
			.then((response) => {
				if (response.status === 200)
					return {
						error: false,
						success: true,
						data: response.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (isCanceledRequest(error)) {
					return {
						error: false,
						success: false,
						canceled: true
					};
				}
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (e) {
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};
